import type * as Types from 'app/types/graphql';

export type ShopShopifySelectFragment = Pick<
  Types.ShopShopify,
  'currency' | 'primary_locale' | 'domain'
>;

export const ShopShopifySelectFragmentDoc = `
    fragment ShopShopifySelect on ShopShopify {
  currency
  primary_locale
  domain
}
    `;
